import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-92">
      <div className="max-w-3xl mx-auto" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-94">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight mb-6" data-id="element-95">
            Tu{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-96">
              paz mental
            </span>{' '}
            también merece protección
          </h2>
          <p className="text-ink-soft text-base md:text-lg mb-3 max-w-2xl mx-auto" data-id="element-97">
            No siempre podés controlar cómo actúan los demás.
          </p>
          <p className="text-ink-soft text-base md:text-lg max-w-2xl mx-auto mb-6" data-id="element-98">
            Pero sí podés aprender a:
          </p>
          <ul className="text-left max-w-md mx-auto space-y-2 mb-8 text-ink-soft" data-id="element-99">
            {['entender mejor ciertas dinámicas', 'poner límites', 'responder con más claridad', 'y dejar de vivir emocionalmente agotado'].map((t, i) => <li key={i} className="flex items-start gap-2" data-id="element-100">
                <span className="text-rose mt-1" data-id="element-101">🌸</span>
                {t}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-rose/30 rounded-3xl p-7 md:p-10 shadow-2xl shadow-rose/10" data-id="element-102">
          <div className="text-center mb-6" data-id="element-103">
            <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-3 py-1 rounded-full mb-4" data-id="element-104">
              <span className="text-[11px] font-bold tracking-widest" data-id="element-105">
                ⭐ OFERTA ESPECIAL
              </span>
            </div>
            <h3 className="font-serif font-bold text-2xl md:text-3xl text-ink uppercase tracking-tight leading-tight" data-id="element-106">
              Cómo Trabajar con{' '}
              <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-107">
                Gente Complicada
              </span>
            </h3>
            <p className="font-serif-italic text-rose text-base mt-1" data-id="element-108">
              6 Módulos + 5 Bonus
            </p>
          </div>

          <div className="text-center mb-6" data-id="element-109">
            <div className="text-muted line-through text-lg mb-1" data-id="element-110">$39.980</div>
            <div className="flex items-baseline justify-center gap-2" data-id="element-111">
              <span className="font-serif font-bold text-5xl md:text-6xl text-rose" data-id="element-112">
                $19.990
              </span>
              <span className="text-base text-ink-soft" data-id="element-113">ARS</span>
            </div>
            <div className="text-sm text-muted mt-2" data-id="element-114">
              Pago único · Acceso de por vida
            </div>
          </div>

          <a href="#oferta" className="flex items-center justify-center gap-2 w-full bg-rose hover:bg-rose-deep text-white font-bold text-lg md:text-xl py-5 rounded-full shadow-xl shadow-rose/30 hover:-translate-y-0.5 transition-all" data-id="element-115">
            <ArrowRightIcon className="w-5 h-5" data-id="element-116" />
            QUIERO ACCEDER AHORA
          </a>

          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-6 text-xs text-muted" data-id="element-117">
            <span className="flex items-center gap-1.5" data-id="element-118">
              <LockIcon className="w-3.5 h-3.5 text-rose" data-id="element-119" /> Pago 100% seguro
            </span>
            <span className="text-line" data-id="element-120">|</span>
            <span className="flex items-center gap-1.5" data-id="element-121">
              <ZapIcon className="w-3.5 h-3.5 text-rose" data-id="element-122" /> Acceso en 5 min
            </span>
            <span className="text-line" data-id="element-123">|</span>
            <span className="flex items-center gap-1.5" data-id="element-124">
              <ShieldCheckIcon className="w-3.5 h-3.5 text-rose" data-id="element-125" /> Garantía 7
              días
            </span>
            <span className="text-line" data-id="element-126">|</span>
            <span className="flex items-center gap-1.5" data-id="element-127">
              <CreditCardIcon className="w-3.5 h-3.5 text-rose" data-id="element-128" /> Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}